<i18n>
{
  "no": {
    "title": "Sett nytt passord",
    "wrongCode" : "Lenken er feil eller utgått",
    "passwordChanged" : "Passordet ble endret.",
    "newPassword": "Nytt passord",
    "mustBeEqual": "Må være likt som passordet",
    "setPassword": "Sett passordet"
  },
  "en": {
    "title": "Set a new password",
    "wrongCode" : "The link was wrong or has expired",
    "passwordChanged" : "The password was changed.",
    "newPassword": "New password",
    "mustBeEqual": "Passwords must be equal",
    "setPassword": "Set password"
  }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div>
        <TnHeading type="h1" size="l" align="center" class="margin-vertical-2xl">
          {{ t('title') }}
        </TnHeading>

        <ErrorMessage :error="error" />

        <TnParagraph v-if="state === States.DONE" size="s">
          {{ t('passwordChanged') }}
        </TnParagraph>

        <TnNotificationInline
          v-else-if="state === States.WRONG_CODE"
          horizontal
          status="critical"
          full-width
        >
          {{ t('wrongCode') }}
        </TnNotificationInline>

        <form
          v-else-if="state === States.CODE_VALIDATED"
          method="post"
          @submit.prevent="submitPassword"
        >
          <div class="field-stack">
            <TnTextField
              v-model="password"
              name="password"
              type="password"
              required
              :label="t('newPassword')"
              :placeholder="t('newPassword')"
            />
            <TnTextField
              v-model="passwordRepeat"
              name="passwordRepeat"
              type="password"
              required
              :label="t('fields.passwordRepeat')"
              :placeholder="t('fields.passwordRepeat')"
              :error="passwordRepeat && passwordRepeat !== password ? t('mustBeEqual') : undefined"
            />
          </div>

          <TnButton
            type="submit"
            primary
            block
            class="margin-top-l"
            :disabled="!valid"
            :text="t('setPassword')"
          />

          <PasswordRules />
        </form>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  TnButton,
  TnHeading,
  TnNotificationInline,
  TnParagraph,
  TnTextField,
} from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import ErrorMessage from '@/views/elvis/components/errorMessage.vue';
import PasswordRules from '@/views/elvis/components/PasswordRules.vue';
import { validateCode, setNewPassword } from './api';

const States = { BEGIN: 0, CODE_VALIDATED: 1, DONE: 2, WRONG_CODE: -1 } as const;

const { t } = useI18n();
const route = useRoute();

const username = (route.query.username as string) ?? '';
const code = (route.query.code as string) ?? '';

const state = ref<number>(States.BEGIN);
const error = ref<unknown>(null);
const password = ref('');
const passwordRepeat = ref('');

const valid = computed(() => password.value === passwordRepeat.value && password.value.length > 6);

function submitPassword() {
  error.value = null;

  setNewPassword(username, code, password.value)
    .then(() => (state.value = States.DONE))
    .catch((err) => (error.value = err));
}

onMounted(() => {
  validateCode(code, username)
    .then(() => (state.value = States.CODE_VALIDATED))
    .catch(() => (state.value = States.WRONG_CODE));
});
</script>
